<!-- Vertical layout -->
@if(isVerticalLayoutRequested()){
<app-vertical></app-vertical>
}

<!-- horizontal layout -->
@if(isHorizontalLayoutRequested()){
<app-horizontal></app-horizontal>}


<!-- Loading spinner -->

<!-- <div class="fadeMe"   >

  

</div> -->

<!-- <div *ngIf="loading" class="loading-container flex-content-center">
    <mat-progress-spinner
      color="primary"
      mode="indeterminate">
    </mat-progress-spinner>
  </div> -->

<!-- <div *ngIf="loading" class="modal" data-backdrop="static" style="display: block;background-color: white; opacity: 0.7;"
  data-keyboard="false" id="modalCustomer" tabindex="-1">
  <div  class="centercontent">
    <div  class="centercontent">
      <mat-progress-spinner color="primary" mode="indeterminate">
      </mat-progress-spinner>
    </div>
  </div>
</div> -->

<style>


</style>